import { createSlice } from "@reduxjs/toolkit";
import { getContentTypeList } from "./thunk";

export interface IState {
  lstContentType: any;
  isContentTypeLoading: boolean;
  isContentTypeSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  lstContentType: null,
  isContentTypeLoading: false,
  isContentTypeSuccess: false,

  error: {},
};

const ContentTypeSlice = createSlice({
  name: "ContentType",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getContentTypeList.pending, (state: IState, action: any) => {
      state.isContentTypeLoading = true;
    });
    builder.addCase(
      getContentTypeList.fulfilled,
      (state: IState, action: any) => {
        state.lstContentType = action.payload.data;
        state.isContentTypeSuccess = true;
        state.isContentTypeLoading = false;
      }
    );
    builder.addCase(
      getContentTypeList.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isContentTypeSuccess = false;
        state.isContentTypeLoading = false;
      }
    );
  },
});

export default ContentTypeSlice.reducer;